// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const CodeContract = contract({
  name: "Code",
  description: "Read-only code surface for marketing heroes, docs, changelog entries, AI-output displays. Use `diff` for the \"diff hero\" pattern (before/after side-by-side or stacked). Use `reveal=\"lines\"` with `trigger=\"inView\"` for scroll-driven marketing pages. Use `reveal=\"typewriter\"` for AI-output / chat-style displays. Use `bare` for inline code inside prose. NOT a code editor — for editable code, reach for an external editor primitive (CodeMirror / Monaco).",
  import: "@gradeui/ui",
  aliases: ["code block","code","code snippet","code surface","syntax highlighted code","diff hero","diff view","diff block","changelog code","before after code","scroll-triggered code","typewriter code"],
  composesWith: ["SectionBlock","Card","Tabs (for multi-file examples)","Carousel (slide-to-slide code progression)"],
  styleDefaults: {"Code":"gds-code relative w-full overflow-hidden"},
  props: {
  "source": {
      schema: z.string(),
      design: "content",
      description: "the code to render",
  },
  "language": {
      schema: z.enum(["tsx", "jsx", "ts", "js", "html", "css", "json", "bash", "md", "py", "go", "rust"]).optional(),
      design: "knob",
      description: "Prism language id; defaults to `tsx`",
  },
  "highlight": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "1-indexed line number, array of numbers, or array of `[start, end]` ranges to emphasise",
  },
  "diff": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "`{ added?: number[]; removed?: number[] }` — 1-indexed lines for diff hero / changelog mode",
  },
  "reveal": {
      schema: z.enum(["none", "lines", "typewriter", "diff"]).optional(),
      design: "knob",
      description: "entrance animation; defaults to `none`",
  },
  "trigger": {
      schema: z.enum(["mount", "inView", "manual"]).optional(),
      design: "knob",
      description: "what kicks the reveal off; defaults to `mount`",
  },
  "play": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "for `trigger=\"manual\"`, set true to play",
  },
  "speed": {
      schema: z.enum(["slow", "normal", "fast"]).optional(),
      design: "knob",
      description: "animation feel preset. `normal` (default) maps to the canonical 50ms/22ms staggers + 180ms pre-delay. Pick a feel; don't tune individual numbers unless you have to.",
  },
  "delay": {
      schema: z.number().optional(),
      design: "knob",
      description: "explicit delay before reveal starts (ms) — overrides the `speed` preset",
  },
  "stagger": {
      schema: z.number().optional(),
      design: "knob",
      description: "explicit per-line stagger for `lines`/`diff`, per-token for `typewriter` (ms) — overrides the `speed` preset",
  },
  "prompt": {
      schema: z.string().optional(),
      design: "content",
      description: "string prepended to each line. Use for terminal emulation: `prompt=\"$ \"` for bash, `prompt=\"> \"` for PowerShell, `prompt=\">>> \"` for Python REPL. Prompt characters render in muted token colour, don't pick up the typewriter stagger, and are hidden from screen readers.",
  },
  "showLineNumbers": {
      schema: z.boolean().optional(),
      design: "knob",
  },
  "filename": {
      schema: z.string().optional(),
      design: "content",
      description: "optional label rendered in the header chrome",
  },
  "wrap": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "wrap long lines instead of horizontal scroll",
  },
  "bare": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "drop chrome (border, header, padding) — for inline use",
  },
  "size": {
      schema: z.enum(["xs", "sm", "md"]).optional(),
      design: "knob",
      description: "type-scale preset. `xs` (12px) for dense changelog cards / inline blocks; `sm` (14px, default) for marketing heroes and docs; `md` (16px) for focal-point displays.",
  },
  "height": {
      schema: z.enum(["auto", "number", "string"]).optional(),
      design: "knob",
      description: "container sizing. `auto` (default) grows with content. Number = pixels (`300` → `300px`). String passes through as CSS (`\"20rem\"`, `\"50vh\"`).",
  },
  "maxLines": {
      schema: z.number().optional(),
      design: "knob",
      description: "cap the visible line count at exactly N line-heights. Wins over `height`. Inherits the current size's line-height automatically.",
  },
  },
});
